import Login from "../components/views/Login.vue";
import store from "../configs/store"; // Alterado de IndexStore para store
import { GET_USUARIO } from "../store/actions.type";
import MinhasLicencas from "../components/views/MinhasLicencas.vue";
import NovoCadastro from "../components/views/NovoCadastro.vue";
import CadastroUsuario from "../components/views/CadastroUsuario.vue";
import VerificarEmail from "../components/views/VerificarEmail.vue";
import RedefinirSenha from "../components/views/RedefinirSenha.vue";
import InformesIpaam from "../components/views/InformesIpaam.vue";
import InformeDetalhe from "../components/views/InformeDetalhe.vue";
import AutenticidadeQr from "../components/views/AutenticidadeQr.vue";
import LoginService from "../services/LoginService";
import { setAccessToken } from "../utils/Autenticacao";

export const routes = [
  {
    path: "/",
    component: MinhasLicencas,
    name: "home",
    beforeEnter: async (to, from, next) => {
      await autenticarPorTicket();
      BuscaUsuarioLogado(next);
    }
  },
  {
    path: "/informacao-carteira/:protocolo",
    name: "informacao-carteira",
    component: AutenticidadeQr
  },
  {
    path: "/novo-cadastro",
    name: "novoCadastro",
    component: NovoCadastro,
    beforeEnter: async (to, from, next) => {
      BuscaUsuarioLogado(next);
    }
  },
  {
    path: "/cadastro-usuario",
    name: "cadastroUsuario",
    component: CadastroUsuario
  },
  {
    path: "/informes-ipaam",
    name: "informesIpaam",
    component: InformesIpaam
  },
  {
    path: "/informe/:id",
    name: "InformeDetalhe",
    component: InformeDetalhe
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/verificar-email",
    name: "verificarEmail",
    component: VerificarEmail
  },
  {
    path: "/redefinir-senha",
    name: "redefinirSenha",
    component: RedefinirSenha
  }
];

async function autenticarPorTicket() {
  const params = new URLSearchParams(window.location.search);
  let ticket = params.get("ticket");

  if (ticket) {
    try {
      if (ticket.endsWith("/")) {
        ticket = ticket.substring(0, ticket.length - 1);
      }
      const response = await LoginService.logarComTicket(ticket);
      if (response.status === 200 && response.data.token) {
        setAccessToken(response.data.token);
      }
    } catch {
      /* falha no ticket: segue para BuscaUsuarioLogado */
    }
  }
}

function BuscaUsuarioLogado(next) {
  store
    .dispatch(GET_USUARIO)
    .then(usuario => {
      if (usuario.login) {
        next();
      } else {
        next("/login");
      }
    })
    .catch(() => {
      next("/login");
    });
}
